import FilterButton from '#/components/FilterButton';
import { FilterState } from '@paradigm/features/src/leaderboard/contexts/filter-provider-factory';
import { useLeaderboardFiltersModalActions } from '@paradigm/features/src/leaderboard/contexts/filters/modal';

interface Props {
  readonly className?: string;
  readonly filterState: FilterState;
}

export default function LeaderboardFilterButton({
  className,
  filterState,
}: Props): JSX.Element {
  const { open } = useLeaderboardFiltersModalActions();
  const start = filterState.end !== null ? 1 : 0;
  const end = filterState.start !== null ? 1 : 0;
  const numOfFiltersSelected =
    filterState.currencies.length +
    filterState.venues.length +
    filterState.instrumentKinds.length +
    filterState.protocols.length +
    start +
    end;
  return (
    <FilterButton
      ariaLabel="open leaderboard volume filters"
      onClick={open}
      activeFiltersCount={numOfFiltersSelected}
      className={className}
      isLeaderboard
    />
  );
}
